import styles from './VKReview.module.css'
import {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import WaitLoader from "../../WaitLoader/WaitLoader";
import logo from '../../Img/VK/logoText.svg'
import question from '../../Img/VK/question.png'
import noPhoto from '../../Img/VK/noPhoto.png'
import {Link, useLocation} from "react-router-dom";
import {Subscription} from "rxjs";
import {useSelector} from "react-redux";
import {ActionMessageInt, ReduxStateInt} from "../../Reducer/GlobalReducer";
import moment from "moment";

interface ICommentItem {
    date: number
    text: string
    name:string
    photoLink:string
    likes:{
        count:number
    }
}

interface IQuestionItem
{
    text:string
    desc?:string
}

export default function VKReview(){

    const dataComment = useRef()
    const [ldrCommentList,rsCommentList,exCommentList] = useApiQuery("/vk/comment/list","get",dataComment);
    const [commentList, setCommentList] = useState<ICommentItem[]>([])
    const [link, setLink] = useState("https://vk.ru")

    const [show, setShow] = useState(false)
    const location = useLocation()

    const refToReview = useRef<HTMLDivElement>(null)



    const subscriber = useRef<Subscription>()
    const rxObserve = useSelector((state: ReduxStateInt) => {
        return state.rxObserve
    })

    const [openQuestion, setOpenQuestion] = useState(-1)
    const [questionList, setQuestionList] = useState<IQuestionItem[]>([
        {
            text: "почему списываются средства за активацию sim карты",
            desc: "Каждый оператор устанавливают свою плату за активацию (выделение) номера. Плата взимается единоразово при активации номера. Обычно эта сумма составляет  100 рублей. Списывается со счета sim карты."

        },
        {
            text: "почему важно знать на кого оформлена sim карта",
            desc :"Всегда обновляйте свои персональные данные на ваших sim картах. Это предотвратит неожиданные блокировки со стороны операторов. Также это нужно для корректного заведения заявки на перенос номера (мнп). Обновить можно в приложении оператора или при визите в салон связи."
        },
        {
            text: "какой срок исполнения заказа",
            desc: "Исполнение заказа начинается после согласования заказа по контактному телефону с клиентом. После этого начинается исполнение заказа, в зависимости от оператора и тарифа срок может составлять от получаса до 2-х дней."
        },
        {
            text: "если у меня есть не оформленная «пустая» sim карта",
            desc: "Некоторые варианты заказа подразумевают возможность использования полученной от наших партнеров «пустой» sim карты для исполнения заказа. Это ускоряет процесс оформления. Уточните перед заказом по нашим контактным телефонам. Не путать с переходом со своим номером - это разные процедуры"
        },
        {
            text: "почему списывается 100 руб. за переннос номера [мнп]",
            desc: "У всех операторов взимается плата за процедуру перехода в размере 100 рублей. Средства списываются единоразово с sim карты оператора к которому Вы переходите. Обычно с временного номера."
        },
        {
            text: "что такое временный номер",
            desc: "Временный номер - это физический номер в федеральном формате необходимый для перехода с другого оператора [мнп]. Выдается оператором, к которому вы переходите. Оформляется при процедуре мнп. В последствии, именно на эту физическую sim карту перейдет Ваш номер, а временный удалится. При переходе к  другому оператору нужно иметь sim карту этого оператора, на которую потом перейдет ваш номер."
        },
        {
            text: "почему не приходят sms при новом подключении",
            desc: "При получении sim карты в салоне связи или выполнения заказа на Вашу «пустую» sim карту выполняется процедура замены sim карты. В целях защиты от мошенничиских действий блокируется прием sms на сутки с момента операции. Остальные сервисы работают в полном объеме. Через сутки прием sms восстановится.",
        },
        {
            text: "какой срок перехода номера с другого оператора [мнп]",
            desc: "Минимальный срок перехода составляет 8 дней. Если в процессе потребуются дополнительные операции и согласования, то срок отсчитывается вновь от момента дополнительных согласований"
        },
        {
            text: "почему при новом подключении начисляется не весь пакет связи",
            desc: "У некотрых тарифов период оплаты составляет месяц и отсчет идет с первого числа. Если Вы подключились, например, в середине месяца, то Вам начислят половину пакета и соответсвенно половину абонентской платы. Со следующего месяца все будет в полном объеме."
        },
        {
            text: "почему нельзя сменить тариф на действующем номере",
            desc: "Некоторые операторы запрещают смену тарифа на уже действующих номерах. Если сервис не дает сменить тариф значит оператор это запрещает."
        },
        {
            text: "как  получить e-sim",
            desc: "e-sim можно получить в любом салоне связи оператора. Имейте в виду, что по новым законам срок действия qr кода ограничен шестью часами. Постарайтесь уложится в этот период, а лучше попросите оператора сразу внести e-sim в Ваш телефон."
        },
        {
            text: "перенос баланса при переходе к другому оператору",
            desc: "При переходе от другого оператора баланс не переносится. Однако вы можете вернуть часть средств у прежнего оператора после перехода. Для этого нужно обратиться в офис предыдущего оператора и написать заявление на возврат неиспользованных средств после процедуры перехода."
        },
    ])


    useEffect(()=>{
        if(!location?.pathname) return
        //console.log("location", location?.pathname)
        if(location?.pathname?.match(/^\/$/ui)){
            setTimeout(()=>setShow(true),2000)
            return
        }

        if(location?.pathname?.match(/^\/lk.*$/ui)){
            setShow(false)
            return
        }
        if(location?.pathname?.match(/^\/order.*$/ui)){
            setShow(false)
            return
        }
        if(location?.pathname?.match(/^\/menu\/contact.*$/ui)){
            setShow(false)
            return
        }
        if(location?.pathname?.match(/^\/tarif.*$/ui)){
            setShow(false)
            return
        }



    },[location,show])


    useEffect(()=>{
        if(subscriber.current)
        {
            try {
                subscriber.current?.unsubscribe()
            } catch (e) {

            }
        }
        //console.log(`Slider ${id.current} add subscriber`)
        subscriber.current = rxObserve.subscribe((e)=>messageMake(e))
        return ()=>{
            //console.log(`Slider ${id.current} remove subscriber`)
            if(subscriber.current)subscriber.current?.unsubscribe()
        }
    })



    useEffect(()=>{


        loadCommentList()


    },[dataComment])



    const messageMake = (message:ActionMessageInt)=>{
        if(message?.message?.match(/moveToReview/ui))
        {
            if(refToReview.current)refToReview.current.scrollIntoView()
        }

    }


    const sortComment = () =>{
        if(commentList?.length === 0) return []
        const x = commentList?.sort((x,y)=>{
            if(x?.date > y?.date) return -1
            if(x?.date < y?.date) return 1
            return 0

        })
        return x
    }

    const loadCommentList = () =>{
        exCommentList().then((e)=>{
            if(e?.success){
                setCommentList(e?.payload?.list)
                setLink(e?.payload?.link)
                setShow(true)
            }
        })
    }

    const buildList = () =>{
        const x = sortComment()?.map((item,idx)=>{

            const date = moment.unix(item?.date).format('DD.MM.YYYY')
            return (
                <div key={idx} className={styles.rvItemCont}>
                    <div className={styles.rvNameCont}>
                        <img src={item?.photoLink ? item?.photoLink : noPhoto}/>
                        {item?.name}
                        <div className={styles.rvDate}>{date}</div>
                    </div>

                    <Link to={link} target={"_blank"} className={styles.rvLink}>
                        <div className={styles.rvTextItem}>{item?.text}</div>
                    </Link>
                    <hr className={styles.rvItemHr}></hr>
                </div>
            )
        })

        return (
            <div className={""}>
                {x}
            </div>
        )

    }

    const buildReview = () =>{
        return(
            <div className={styles.rvBlock} ref={refToReview}>
                <div className={styles.mainCont} >
                    <div className={styles.rvCont} >

                        <div className={styles.rvLogoCont}>
                            <Link to={link} className={styles.rvLink} target={"_blank"}>
                                <img src={logo} alt={"Лого"}/>
                            </Link>
                        </div>
                        {buildList()}

                        <div className={styles.rvBtnCont}>
                            <Link to={link} target={"_blank"} className={styles.rvLink}>
                                <div className={styles.rvBtn}>оставить отзыв</div>
                            </Link>
                        </div>
                    </div>

                </div>

            </div>

        )
    }


    const buildQuestion= (odd: boolean) =>{
        const x = questionList?.map((item, idx)=>{
            if(odd && (idx % 2)) return null
            if(!odd && (idx % 2) === 0) return null

            const opened = openQuestion === idx
            return (
                <div key={idx} className={styles.qItemCont}>
                    <div className={[styles.qItem, opened ? styles.qItemActive : ""].join(' ')}
                         onClick={()=>setOpenQuestion(opened ? -1 :idx)}
                    >
                        {item?.text}
                        <div className={styles.qLogo}><img src={question} alt={"Лого"}/></div>
                    </div>
                    {opened &&
                        <div className={styles.qDescCont}>
                            {item?.desc}
                        </div>

                    }
                </div>
            )

        })
        return (
            <div className={styles.qCont}>
                {x}
            </div>
        )


    }



    if(!show || ldrCommentList) return null
    return(

        <WaitLoader loading={ldrCommentList} api={rsCommentList} onlyLoading={true}>


            <div className={styles.xCont}>
                <div className={styles.rvTitle}>Отзывы о тарифах и сервисе, частые вопросы</div>
                <div className={styles.rowCont}>
                    {buildQuestion(true)}
                    {buildReview()}
                    {buildQuestion(false)}
                </div>
            </div>



        </WaitLoader>
    )
}